function hideButton() {
  var header = document.getElementsByClassName("shopify-section-group-header-group");
  var popUp = document.getElementById("violaSplash");
  localStorage["splash-popup"] = "test";
  popUp.style.display = "none";
  popUp.style.visibility = "hidden";
  for (let ele of header) {
    ele.style.zIndex = "9999999999";
  }
  destroyVideo();
}

function GoToGoogle() {
  window.location.href = "https://google.com";
  destroyVideo();
}

function destroyVideo() {
  var backgroundVideoMobile = document.getElementById("splash-video-mobile");
  var backgroundVideo = document.getElementById("splash-video");
  if (null != backgroundVideo) {
    backgroundVideo.innerHTML = "";
  }

  if (null != backgroundVideoMobile) {
    backgroundVideoMobile.innerHTML = "";
  }
}
  
setTimeout(function () {
  var popUp = document.getElementById("violaSplash");
  var hasSeen = (null != localStorage["splash-popup"]);
  var header = document.getElementsByClassName("shopify-section-group-header-group");
  
  console.log("header", header);
  if (!hasSeen) {
      for (let ele of header) {
        ele.style.zIndex = "1";
      }
      console.log("popUp", popUp);
      popUp.style.display = "grid";
      popUp.style.visibility = "visible";
  } else {
    for (let ele of header) {
       ele.style.zIndex = "999999";
    }
    popUp.style.display = "none";
    popUp.style.visibility = "hidden";
  }
}, 500);


